import React, { useState } from "react";
import { TbCaretDownFilled, TbWorld } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import NavOptionDropdown from "../nav/NavOptionDropdown";

function NavOption({ item, index, currentLanguage, handleNavItemClick }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);

  const isActivePath = (paths) => {
    for (const path of paths) {
      if (location.pathname === path) return true;
    }
    return false;
  };

  const handleKeyDown = (event, path) => {
    if (event.key === "Enter") {
      navigate(path);
    }
  };

  return (
    <li
      className={`nav-option ${
        isActivePath([
          item.path,
          ...item.dropdownSections.flatMap((section) =>
            section.items.map((i) => i.path || i.link)
          ),
        ])
          ? "active-nav"
          : ""
      }`}
      onMouseEnter={() => setHoveredItem(index)}
      onMouseLeave={() => setHoveredItem(null)}
      onFocus={() => setHoveredItem(index)}
    >
      <div
        className="nav-item-container"
        onClick={() => handleNavItemClick(item.path)}
        onKeyDown={(event) => handleKeyDown(event, item.path)}
        tabIndex="0"
      >
        {item.name[currentLanguage]}
        <span className="nav-caret">
          <TbCaretDownFilled className="caret" size={20} />
        </span>
      </div>

      {hoveredItem === index && (
        <div
          className={`desktop-nav-dropdown-container desktop-nav-dropdown-container-${item.className
            .toLowerCase()
            .replace(/\s+/g, "-")}`}
        >
          {item.dropdownSections.map((section, sectionIndex) => (
            <NavOptionDropdown
              section={section}
              sectionIndex={sectionIndex}
              item={item}
              currentLanguage={currentLanguage}
            />
          ))}
        </div>
      )}
    </li>
  );
}

export default NavOption;
